import styled from '@emotion/styled';
import { BackButton } from 'components';
import { mobileHeaderSize } from 'layouts/MobileLayout/MobileHeader/MobileHeader.style';

export const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    margin: ${({ theme }) => theme.base.spacing[4]};
`;

export const TitleContainer = styled.div`
    height: ${mobileHeaderSize};
    position: sticky;
    top: 0;
    background-color: ${({ theme }) => theme.base.color.backgroundMain};
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: ${({ theme }) => theme.base.spacing[8]};
`;

export const AbsoluteBackButton = styled(BackButton)`
    position: absolute;
    left: 0;
`;
